const PIXEL_ID = '2025373898394216'

let initialized = false
let pending = false
let viewContentFired = false
let purchaseFired = false

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number
  }
}

function loadPixel() {
  if (initialized || typeof window === 'undefined') return
  ;(function (f: any, b: any, e: any, v: any) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e)
    t.async = !0
    t.defer = !0
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
  initialized = true
}

export function initPixel() {
  if (initialized || pending || typeof window === 'undefined') return
  pending = true

  // Defer until browser is idle to avoid competing with first paint / hero render.
  const start = () => {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(
        () => {
          loadPixel()
          trackViewContent()
        },
        { timeout: 3000 },
      )
    } else {
      setTimeout(() => {
        loadPixel()
        trackViewContent()
      }, 1500)
    }
  }

  if (document.readyState === 'complete') {
    start()
  } else {
    window.addEventListener('load', start, { once: true, passive: true })
  }
}

export function trackViewContent() {
  if (typeof window === 'undefined' || viewContentFired) return
  if (!initialized) loadPixel()
  try {
    window.fbq &&
      window.fbq('track', 'ViewContent', {
        content_name: 'Sistema iPhone Ads',
        content_category: 'Ebook / Guía digital',
        content_ids: ['sistema-iphone-ads'],
        content_type: 'product',
        currency: 'ARS',
        value: 14900,
      })
    viewContentFired = true
  } catch (e) {
    // silent fail
  }
}

export function trackInitiateCheckout() {
  if (typeof window === 'undefined') return
  if (!initialized) loadPixel()
  try {
    window.fbq &&
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Sistema iPhone Ads',
        content_category: 'Ebook / Guía digital',
        content_ids: ['sistema-iphone-ads'],
        content_type: 'product',
        currency: 'ARS',
        value: 14900,
      })
  } catch (e) {
    // silent fail
  }
}

export function trackPurchase() {
  if (typeof window === 'undefined' || purchaseFired) return
  if (!initialized) loadPixel()
  try {
    window.fbq &&
      window.fbq('track', 'Purchase', {
        content_name: 'Sistema iPhone Ads',
        content_category: 'Ebook / Guía digital',
        content_ids: ['sistema-iphone-ads'],
        content_type: 'product',
        currency: 'ARS',
        value: 15000,
      })
    purchaseFired = true
  } catch (e) {
    // silent fail
  }
}
